import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e84ff9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "StereoProjectionRenderContainer"
};
const _hoisted_2 = {
  class: "flex justify-center"
};
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mt-4"
}, "题目给出了正方体四周的观察视角， 请在选项中选择俯视视角下第二层的方块分布结果 （包括旋转后相同）。", -1));
const _hoisted_5 = {
  key: 0,
  class: "mt-4 flex justify-center gap-2 flex-wrap"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 1,
  class: "question-cube-preview"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center mt-4"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "ft20"
}, "请选择答案")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IceCubeItem = _resolveComponent("IceCubeItem");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_LogicalTransformer2DImg = _resolveComponent("LogicalTransformer2DImg");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]), _hoisted_4, $options.questionImages.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.questionImages, img => {
    return _openBlock(), _createElementBlock("img", {
      key: img,
      src: img,
      style: {
        "width": "230px"
      }
    }, null, 8, _hoisted_6);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(), _createBlock(_component_IceCubeItem, {
    "cube-positions": $props.data.blocks,
    key: `IceCubeItem${$props.data.questionIndex}`,
    "is-svae": false,
    "view-point": null,
    subject: "StereoProjection"
  }, null, 8, ["cube-positions"]))])), _hoisted_8, $props.reviewMode ? (_openBlock(), _createBlock(_component_el_divider, {
    key: 2
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1)]),
    _: 1
  })) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    key: `StereoProjection_${$props.data.questionIndex}`,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: ['A', 'B', 'C', 'D']
  }, {
    default: _withCtx(btnIndex => [_createVNode(_component_LogicalTransformer2DImg, {
      grid: $props.data.answers[btnIndex.index]
    }, null, 8, ["grid"])]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode"]))]);
}